import React from "react";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";

interface ParamProps {
  fieldName: string;
  label: string;
  isDisable?: boolean;
  isInvalid?: boolean;
  currentObject: any;
  getValue: number | undefined | null;
  setValue: (updatedObject: any) => void;
  mode?: "decimal" | "currency";
  suffix?: string;
  inputMode?: "decimal" | "numeric" | "text";
}

const MobileInputCurrencyComponent: React.FC<ParamProps> = (params: ParamProps) => {
  const handleChange = (e: InputNumberChangeEvent) => {
    const newValue = e.value;
    const updatedObject = {
      ...params.currentObject,
      [params.fieldName]: newValue,
    };
    params.setValue(updatedObject);
  };

  const handleBlur = () => {
    // Garantir que ao sair do campo, se o valor for null/undefined, vira 0
    const currentValue = params.getValue;
    if (currentValue === null || currentValue === undefined) {
      const updatedObject = {
        ...params.currentObject,
        [params.fieldName]: 0,
      };
      params.setValue(updatedObject);
    }
  };

  return (
    <InputNumber
        className="w-full"
        placeholder={params.label}
        value={params?.getValue}
        onChange={handleChange}
        onBlur={handleBlur}
        mode={params.mode || "currency"}
        currency={params.mode === "decimal" ? undefined : "EUR"}
        suffix={params.suffix}
        disabled={params.isDisable || false}
        invalid={params.isInvalid || false}
        locale="pt-PT"
        inputMode={params.inputMode}
    />
  );
};

export default MobileInputCurrencyComponent;
